import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

const STORAGE_KEY = 'auth.redirectUrl';

@Component({
    selector: 'app-redirect',
    imports: [],
    templateUrl: './redirect.component.html',
    styleUrl: './redirect.component.scss'
})
export class RedirectComponent {

}
// @Component({
//   selector: 'app-redirect',
//   standalone: true,
//   template: `<p>Redirecting...</p>`
// })
// export class RedirectComponent implements OnInit {
//   constructor(private router: Router) { }

//   ngOnInit(): void {
//     console.log('REDIRECT COMPONENT INITIATED');
//     const savedRoute = sessionStorage.getItem(STORAGE_KEY);

//     sessionStorage.removeItem(STORAGE_KEY);

//     if (savedRoute && savedRoute.startsWith('/')) {
//       console.warn(`%cRedirecting to saved route: ${savedRoute}`, 'color: green');
//       this.router.navigateByUrl(savedRoute);
//     } else {
//       console.warn('Invalid or missing saved route', savedRoute);
//       this.router.navigate(['/flights/flight-table']);
//     }
//   }
// }


